














































import { Component, Mixins } from "vue-property-decorator";
import BannerMixin from "@/helpers/mixins/BannerMixin";

@Component
export default class BannerBox extends Mixins(BannerMixin) {
  //  public  iconsclickfunc

  $router;

  async iconsclickfunc(targetUrl: string) {
    console.log("iconsclickfunc");
    console.log("targetUrl", targetUrl);
    //  '/'
    if (targetUrl === "/") {
      return;
    }
    //   'http开头'
    if (targetUrl.includes("http")) {
      window.open(targetUrl);
      return;
    }
    // 站内
    this.$router.push({ path: targetUrl });
    // await this.$router.push({path: `/myAccount/rewardPoints/pointGuide?pageSize=${this.pageSize}&pageIndex=${value}`})
  }
}
